import { render, staticRenderFns } from "./PositionView.vue?vue&type=template&id=499f8272&scoped=true"
import script from "./PositionView.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionView.vue?vue&type=style&index=0&id=499f8272&prod&lang=css"
import style1 from "./PositionView.vue?vue&type=style&index=1&id=499f8272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499f8272",
  null
  
)

export default component.exports